/* eslint-disable @typescript-eslint/camelcase */
import { AppService } from './AbstractService';

export default class TransactionService extends AppService {
  public updateDepositRequest(data: { request_id: string; status: string }) {
    return this.makeRequest('PUT', '/transactions/deposit', data);
  }

  public updateWithdrawRequest(data: {
    request_id: string; status: string; transferType: string; bankTransfer: boolean;
  }) {
    return this.makeRequest('PUT', '/transactions/withdraw', data);
  }

  public getRequestSummary(type: string, range: string, search: string = '') {
    return this.makeRequest('GET', `/transactions/admin/${type}/summary?range=${range}&search=${search}`);
  }

  public getTransactionSummary(data: { range: string; user_id?: string; account_number?: string }) {
    return this.makeRequest('GET', `/transactions/summary?range=${data.range}&user_id=${data.user_id || ''}&account_number=${data.account_number || ''}`);
  }

  public depositByAdmin(data: {
    to_bank: string;
    to_account_number: string;
    amount: number;
    user_id: string;
    request_time: number;
  }) {
    return this.makeRequest('POST', '/transactions/admin-deposit', data);
  }

  public withdrawByAdmin(data: {
    withdrawAmount: number;
    user_id: string;
  }) {
    return this.makeRequest('POST', '/transactions/admin-withdraw', data);
  }

  public getSummaryByType(data: {
    range: string;
    type: string;
    account_number?: string;
    promotion_id?: string;
  }) {
    return this.makeRequest('GET', `/transactions/summary/${data.type}?range=${data.range}&account_number=${data.account_number || ''}&promotion_id=${data.promotion_id || ''}`);
  }

  public deleteTransaction(transactionId: string) {
    return this.makeRequest('DELETE', `/transactions/${transactionId}`);
  }

  public getRefundSummary(period: string) {
    return this.makeRequest('GET', `/transactions/refund/summary?range=${period}`);
  }

  public transferMoneyToWithdrawAccount(amount: number) {
    return this.makeRequest('POST', '/transactions/transfer-to-withdraw-account', { amount });
  }

  public transferMoneyToSavingAccount(amount: number) {
    return this.makeRequest('POST', '/transactions/transfer-to-saving-account', { amount });
  }

  public getBalance(type: string) {
    return this.makeRequest('GET', `/transactions/admin/balance/${type}`);
  }

  public cancelZappayWithdraw(uuid: string) {
    return this.makeRequest('DELETE', `/zappay/withdraw/${uuid}`);
  }
}
